// Die feste Palette der Uebungsart "Reagieren": alle Redewendungen, aus denen
// der Lernende seine Sprueche baut — immer dieselben, immer in derselben
// Reihenfolge, damit man sie wiederfindet wie auf einem Formular.
// Was zur Lage gehoert (Rufnamen, Meldung, Kanal …), steht NICHT hier; das
// nimmt die Ansicht aus der Uebung.
//
// Ein Eintrag ist genau ein Baustein, so wie er in daten.js steht —
// "falsch ich wiederhole" ist EINE Redewendung, "nicht verstanden" auch.
// Fremdwoerter ("over", "roger") kommen bewusst nicht vor.
//
// Wer hier etwas aendert: jeder feste Baustein aus daten.js, der keine
// Lage-Angabe ist, muss hier stehen, sonst kann ihn niemand bauen.

// Gruppen nach Funktion, abgeleitet aus den Bedeutungen im Behelf
// (VERSTANDEN bestaetigt den Empfang, FALSCH leitet eine Korrektur ein …).
// Der Behelf selbst fuehrt die Redewendungen als flache Liste; die Gruppen
// sind eine Ordnung der App, damit man schneller findet. Sie erscheinen
// bewusst OHNE Ueberschrift (Stufe «Selbst funken»: keine Hilfen, die
// verraten, wozu ein Baustein dient).
//   1. bestaetigen   2. Fehler und Rueckfrage   3. Verstaendlichkeit
//   4. Befehl        5. Ablauf
export const redewendungsGruppen = [
    ['verstanden', 'richtig'],
    ['falsch', 'nicht verstanden', 'wiederholen', 'ich wiederhole', 'falsch ich wiederhole'],
    ['ONE', 'TWO', 'THREE'],
    ['auf meinen Befehl', 'auf deinen Befehl', 'ausführen'],
    ['antworten', 'bitte warten', 'Schluss']
]

// Dieselben Bausteine als eine Liste, fuer alles, was nur wissen muss,
// ob ein Text eine Redewendung ist.
export const redewendungen = redewendungsGruppen.flat()
